var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g5, _path24, _g6, _path25, _g7, _path26, _g8, _path27, _g9, _path28, _g10, _path29, _g11, _path30, _g12, _path31, _g13, _path32, _g14, _path33, _g15, _path34, _g16, _path35, _g17, _path36, _g18, _path37, _g19, _path38, _g20, _path39, _g21, _path40, _g22, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g23, _path56, _g24, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 399,
    viewBox: "0 0 399 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1697 23.0938C83.5648 42.1402 98.9533 73.4142 78.9129 87.6355C59.405 101.479 35.8643 78.2039 17.4924 90.1034C-9.76156 107.755 -5.68333 189.886 33.3523 241.299C45.0914 256.761 54.9717 262.832 59.1934 280.224C68.2586 317.567 34.7894 339.372 40.9209 357.859C54.7261 399.485 273.373 436.591 362.563 312.868C404.218 255.084 411.243 171.086 375.245 106.852C310.195 -9.21389 127.697 -19.6423 97.1697 23.0938Z",
    fill: "#FAF4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.3 312.564C227.615 324.6 220.167 334.212 213.79 340.34C212.698 340.076 211.989 340.221 210.822 340.215C200.28 340.161 195.923 337.773 185.635 335.991C183.422 335.608 177.363 332.38 174.976 330.889L170.574 328.032C170.574 328.032 168.557 299.655 183.785 295.741C199.013 291.828 200.369 264.422 202.786 249.894C209.345 210.472 250.251 224.375 262.728 174.391C266.047 161.097 267.931 134.634 281.775 126.831C297.548 117.941 303.928 132.095 314.651 124.047C331.408 111.467 353.644 110.988 362.024 130.306C370.296 149.371 347.478 177.556 304.09 193.982C274.299 209.29 272.323 215.601 270.372 231.677C269.005 242.937 272.35 273.988 254.695 281.666C237.042 289.341 222.655 298.804 225.3 312.564Z",
    fill: "url(#paint0_linear_12_241)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 170,
    y: 115,
    width: 194,
    height: 233
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.141 347.571L171.147 329.187C171.147 329.187 168.557 299.653 183.785 295.74C199.013 291.826 200.369 264.421 202.786 249.893C209.345 210.471 250.251 224.374 262.728 174.39C266.047 161.096 267.931 134.633 281.775 126.83C297.548 117.94 303.928 132.094 314.651 124.046C331.408 111.466 353.644 110.987 362.024 130.305C370.296 149.37 347.478 177.555 304.09 193.98C274.299 209.289 272.323 215.6 270.372 231.675C269.005 242.936 272.35 273.987 254.696 281.665C237.041 289.343 222.653 298.804 225.299 312.564C229.326 333.499 205.141 347.571 205.141 347.571Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_241)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.796 337.705L190.081 337.429C191.723 333.169 193.43 328.894 195.157 324.721C207.944 293.824 223.152 265.238 240.359 239.759C254.94 218.17 271.157 198.503 288.56 181.304C302.555 167.473 317.39 155.156 332.652 144.696C343.381 137.344 354.209 130.976 364.835 125.774C366.686 124.866 368.63 124.043 370.512 123.246C373.017 122.184 375.608 121.086 377.999 119.783L378.366 120.456C375.942 121.776 373.333 122.882 370.811 123.952C368.94 124.744 367.006 125.565 365.173 126.462C354.579 131.649 343.785 137.997 333.086 145.33C317.863 155.764 303.063 168.051 289.099 181.851C271.733 199.014 255.547 218.641 240.995 240.19C223.816 265.626 208.632 294.165 195.865 325.014C194.14 329.181 192.434 333.451 190.796 337.705Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.793 203.646L268.198 203.163C288.937 177.642 290.306 121.305 290.317 120.74L291.084 120.755C291.073 121.323 289.698 177.922 268.793 203.646Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.037 280.126L216.391 279.715C228.455 260.721 271.207 254.375 271.637 254.313L271.747 255.071C271.319 255.132 228.914 261.429 217.037 280.126Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.123 291.494L210.414 291.205C215.974 277.609 216.29 256.098 211.306 230.635C211.056 229.354 211.056 229.354 211.109 229.219L211.822 229.5L211.465 229.359L211.847 229.357C211.854 229.443 211.948 229.927 212.059 230.487C217.07 256.095 216.739 277.76 211.123 291.494Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.901 329.975L193.305 329.495C203.456 316.898 227.451 316.896 227.693 316.898L227.689 317.665C227.45 317.662 203.82 317.666 193.901 329.975Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.657 337.483C189.925 324.441 186.456 310.894 179.054 296.071L179.74 295.729C187.199 310.667 190.693 324.33 190.424 337.499L189.657 337.483Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.199 151.637L323.632 151.122C335.953 137.575 345.758 120.487 348.979 114.872C349.759 113.513 350.035 113.035 350.16 112.886L350.748 113.377C350.655 113.492 350.209 114.27 349.643 115.253C346.412 120.886 336.575 138.03 324.199 151.637Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.906 170.699L300.517 170.039C315.301 161.302 348.533 169.961 349.94 170.335L349.744 171.076C349.402 170.986 315.413 162.126 300.906 170.699Z",
    fill: "#FCFDFE"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 193,
    width: 179,
    height: 177
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.256 351.496L217.53 369.95C217.53 369.95 232.695 357.895 231.957 342.411C230.452 310.822 258.223 311.708 269.911 310.339C287.537 308.274 302.169 298.767 288.187 282.225C274.206 265.682 308.414 249.237 337.361 250.005C365.687 250.756 383.367 200.837 322.209 193.583C285.685 189.249 271.703 222.251 260.681 237.236C249.657 252.223 225.323 239.184 221.594 263.427C218.409 284.134 224.141 304.145 207.244 309.416C190.347 314.688 181.556 326.788 187.256 351.496Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.256 351.496L217.53 369.95C217.53 369.95 232.695 357.895 231.957 342.411C230.452 310.822 258.223 311.708 269.911 310.339C287.537 308.274 300.15 299.414 290.572 282.839C279.734 264.085 308.415 249.237 337.361 250.005C365.687 250.756 383.367 200.837 322.209 193.583C285.685 189.249 271.703 222.251 260.681 237.236C249.657 252.223 225.323 239.184 221.594 263.427C218.409 284.134 224.141 304.145 207.244 309.416C190.347 314.688 181.556 326.788 187.256 351.496Z",
    fill: "url(#paint1_linear_12_241)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 193,
    width: 179,
    height: 177
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.256 351.496L217.53 369.95C217.53 369.95 232.695 357.895 231.957 342.411C230.452 310.822 258.223 311.708 269.911 310.339C287.537 308.274 302.169 298.767 288.187 282.225C274.206 265.682 308.414 249.237 337.361 250.005C365.687 250.756 383.367 200.837 322.209 193.583C285.685 189.249 271.703 222.251 260.681 237.236C249.657 252.223 225.323 239.184 221.594 263.427C218.409 284.134 224.141 304.145 207.244 309.416C190.347 314.688 181.556 326.788 187.256 351.496Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_12_241)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.645 362.294L199.344 362.562C199.51 362.129 216.283 318.85 245.849 280.961C273.086 246.053 317.07 208.711 371.93 229.041L372.19 228.34C347.769 219.289 323.437 220.717 299.87 232.584C281.043 242.063 262.666 258.188 245.25 280.513C215.62 318.49 198.813 361.859 198.645 362.294Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.237 237.966L290.92 238.274C301.159 215.563 327.48 190.48 327.744 190.229L327.23 189.685C326.963 189.938 300.537 215.123 290.237 237.966Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.156 230.49C335.843 230.2 352.023 248.886 352.182 249.075L352.753 248.59C352.591 248.399 336.199 229.449 306.149 229.741L306.156 230.49Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.87 306.783C253.385 281.006 298.873 298.598 299.302 298.807L299.672 298.157C299.271 297.913 253.08 280.251 227.339 306.256L227.87 306.783Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.457 293.895L236.163 294.147C243.933 272.347 231.061 246.24 230.93 245.979L230.262 246.314C230.389 246.573 243.118 272.4 235.457 293.895Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.134 355.809C210.206 344.642 232.612 345.563 232.836 345.573L232.872 344.826C231.936 344.782 209.836 343.875 201.528 355.371L202.134 355.809Z",
    fill: "#F22115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.968 345.507L206.664 345.783C210.688 335.66 203.055 316.997 200.547 310.864C200.192 309.998 199.887 309.25 199.858 309.105L199.121 309.238C199.158 309.442 199.36 309.94 199.854 311.147C202.333 317.21 209.88 335.663 205.968 345.507Z",
    fill: "#F22115"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.728 379.522C240.582 379.551 240.437 379.579 240.291 379.608C231.639 381.252 221.894 381.52 211.008 379.539C208.913 379.004 206.819 378.467 204.723 377.932C204.058 372.532 204.394 367.278 211.246 366.745C221.889 365.919 225.936 348.39 224.543 341.579C222.818 333.147 219.203 313.432 235.636 311.895C249.317 310.616 258.406 312.587 262.872 296.295C267.336 280.003 278.561 271.665 293.299 275.883C308.81 280.32 326.245 262.168 337.618 271.963C357.435 289.03 329.224 320.956 299.631 325.57C270.039 330.183 283.577 343.416 281.393 357.067C278.412 375.703 254.365 366.379 246.221 372.191C243.462 374.158 241.762 376.776 240.728 379.522Z",
    fill: "url(#paint2_linear_12_241)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 204,
    y: 269,
    width: 141,
    height: 121
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.257 389.83L205.034 382.141C204.129 376.849 203.591 367.339 211.246 366.744C221.889 365.918 225.936 348.389 224.543 341.577C222.818 333.146 219.203 313.43 235.636 311.894C249.317 310.614 258.406 312.585 262.872 296.294C267.336 280.002 278.561 271.664 293.299 275.881C308.81 280.319 326.245 262.167 337.618 271.962C357.435 289.029 329.224 320.955 299.631 325.568C270.039 330.182 283.577 343.415 281.393 357.065C278.412 375.701 254.365 366.378 246.221 372.19C239.837 376.745 239.1 384.779 239.257 389.83Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_12_241)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.352 380.826L223.656 380.519C246.08 329.675 293.072 289.962 346.292 276.88L346.474 277.618C293.478 290.645 246.684 330.192 224.352 380.826Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.953 354.153L238.211 353.99C242.904 332.661 228.303 312.017 228.156 311.812L228.774 311.369C228.923 311.576 243.72 332.487 238.953 354.153Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.732 371.585L228.157 371.089C242.613 354.318 282.495 360.27 282.895 360.333L282.779 361.084C282.383 361.021 242.912 355.133 228.732 371.585Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.484 313.753L274.868 313.308C285.157 299.073 280.216 272.597 280.165 272.331L280.91 272.188C280.963 272.456 285.965 299.255 275.484 313.753Z",
    fill: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.675 293.917L304.425 293.198C323.33 286.628 347.877 297.958 348.123 298.073L347.8 298.762C347.557 298.648 323.286 287.449 304.675 293.917Z",
    fill: "#FCFDFE"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C104.204 20.3547 47.9201 73.9467 47.9201 140.056C47.9201 180.177 68.6506 215.685 100.468 237.404C113.967 246.618 122.153 261.805 122.153 278.148V287.308C122.153 307.211 138.289 323.346 158.191 323.346H189.076C208.979 323.346 225.114 307.212 225.114 287.308V278.148C225.114 261.805 233.3 246.618 246.799 237.404C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "#F5EFFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.634 391.48C189.035 391.48 201.521 384.87 201.521 376.717C201.521 368.563 189.035 361.953 173.634 361.953C158.232 361.953 145.746 368.563 145.746 376.717C145.746 384.87 158.232 391.48 173.634 391.48Z",
    fill: "url(#paint3_linear_12_241)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.583 350.343V365.421C136.583 370.521 139.486 375.196 144.091 377.391C150.482 380.44 161.111 383.785 176.556 383.389C189.086 383.068 197.257 381.022 202.451 378.872C207.469 376.795 210.686 371.833 210.686 366.402V358.059L136.583 350.343Z",
    fill: "url(#paint4_linear_12_241)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M136.583 363.549C137.712 364.647 139.02 365.578 140.49 366.278C147.661 369.698 194.633 377.34 205.963 373.081C207.434 372.529 208.757 371.789 209.917 370.898C210.413 369.473 210.686 367.958 210.686 366.4V358.058L136.583 350.342V363.549Z",
    fill: "url(#paint5_linear_12_241)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.872 340.085C135.698 339.651 132.066 342.924 132.066 347.12V347.547C132.066 353.27 135.322 358.514 140.488 360.976C147.659 364.395 194.631 372.038 205.961 367.779C211.665 365.636 215.2 360.739 215.2 354.646V354.302C215.2 350.68 212.462 347.642 208.859 347.267L139.872 340.085Z",
    fill: "url(#paint6_linear_12_241)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M208.859 347.269L139.872 340.085C137.15 339.801 134.666 341.1 133.262 343.199C134.648 346.465 137.171 349.196 140.488 350.778C147.659 354.197 196.63 362.835 205.961 358.438C209.594 356.727 212.441 353.838 213.967 350.326C212.831 348.659 211.001 347.492 208.859 347.269Z",
    fill: "url(#paint7_linear_12_241)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.174 315.657C134.354 315.657 132.068 317.943 132.068 320.763V332.572C132.068 338.294 135.324 343.538 140.49 346.001C147.661 349.42 196.632 358.058 205.963 353.662C211.475 351.064 215.201 345.765 215.201 339.672V320.763C215.201 317.943 212.915 315.657 210.095 315.657H137.174Z",
    fill: "url(#paint8_linear_12_241)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.634 328.918C196.022 328.918 214.172 324.627 214.172 319.333C214.172 314.04 196.022 309.748 173.634 309.748C151.245 309.748 133.096 314.04 133.096 319.333C133.096 324.627 151.245 328.918 173.634 328.918Z",
    fill: "url(#paint9_linear_12_241)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C104.204 20.3547 47.9201 73.9467 47.9201 140.056C47.9201 180.177 68.6506 215.685 100.468 237.404C113.967 246.618 122.153 261.805 122.153 278.148V287.308C122.153 307.211 138.289 323.346 158.191 323.346H189.076C208.979 323.346 225.114 307.212 225.114 287.308V278.148C225.114 261.805 233.3 246.618 246.799 237.404C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "url(#paint10_linear_12_241)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.634 318.789C190.016 318.789 203.297 315.649 203.297 311.776C203.297 307.903 190.016 304.763 173.634 304.763C157.251 304.763 143.97 307.903 143.97 311.776C143.97 315.649 157.251 318.789 173.634 318.789Z",
    fill: "#F5EFFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.903 316.062C165.054 316.062 164.316 315.431 164.205 314.566L142.382 144.861C142.262 143.923 142.925 143.064 143.865 142.943C144.806 142.816 145.663 143.485 145.783 144.424L167.606 314.129C167.726 315.068 167.063 315.927 166.123 316.047C166.049 316.057 165.977 316.062 165.903 316.062Z",
    fill: "url(#paint11_linear_12_241)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M179.457 316.062C179.385 316.062 179.311 316.057 179.237 316.047C178.298 315.927 177.635 315.068 177.754 314.129L199.577 144.424C199.698 143.485 200.555 142.815 201.495 142.943C202.434 143.064 203.097 143.923 202.978 144.861L181.155 314.566C181.045 315.431 180.308 316.062 179.457 316.062Z",
    fill: "url(#paint12_linear_12_241)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M197.23 144.724C196.673 144.724 196.126 144.452 195.797 143.953L189.775 134.816C189.712 134.723 189.617 134.669 189.53 134.679C189.381 134.681 189.317 134.788 189.298 134.822L185.322 141.482C184.663 142.585 183.507 143.262 182.232 143.295C180.964 143.336 179.765 142.707 179.05 141.635L173.59 133.449C173.53 133.361 173.45 133.314 173.354 133.314C173.237 133.335 173.184 133.355 173.125 133.439L168.329 140.371C167.636 141.374 166.5 141.973 165.29 141.974H165.283C164.073 141.974 162.935 141.378 162.238 140.378L155.323 130.472C155.26 130.383 155.172 130.352 155.079 130.343C154.979 130.348 154.902 130.397 154.849 130.491L148.537 141.387C148.062 142.204 147.013 142.484 146.194 142.01C145.374 141.536 145.095 140.486 145.57 139.667L151.882 128.771C152.524 127.664 153.666 126.971 154.935 126.917C156.195 126.853 157.402 127.459 158.134 128.51L165.048 138.416C165.108 138.501 165.188 138.545 165.283 138.545C165.375 138.544 165.452 138.503 165.51 138.42L170.307 131.488C171.008 130.474 172.164 129.87 173.384 129.885C174.612 129.896 175.755 130.517 176.442 131.547L181.902 139.732C181.963 139.825 182.056 139.901 182.147 139.867C182.296 139.864 182.358 139.758 182.378 139.724L186.354 133.064C187.016 131.956 188.174 131.279 189.455 131.251C190.722 131.222 191.927 131.85 192.637 132.929L198.66 142.065C199.181 142.855 198.962 143.918 198.171 144.44C197.881 144.633 197.553 144.724 197.23 144.724Z",
    fill: "url(#paint13_linear_12_241)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M175.916 234.473C178.609 188.336 256.387 177.538 256.054 136.336C255.848 110.959 224.942 92.1127 218.342 88.3384C169.712 60.5235 109.853 92.6438 97.4921 69.9111C94.4135 64.251 95.8577 58.0896 96.6799 54.5808C97.9223 49.2786 100.734 44.3384 104.906 39.8214C70.5945 61.1952 47.9215 98.1023 47.9215 140.056C47.9215 180.177 68.652 215.685 100.47 237.404C113.968 246.618 122.155 261.805 122.155 278.148V287.308C122.155 307.211 138.29 323.346 158.193 323.346H189.077C208.98 323.346 225.116 307.212 225.116 287.308V279.984C220.864 283.241 215.982 285.513 210.629 285.469C192.052 285.317 174.575 257.433 175.916 234.473Z",
    fill: "url(#paint14_linear_12_241)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M175.644 249.051C235.39 249.051 283.824 202.342 283.824 144.724C283.824 87.1053 235.39 40.3965 175.644 40.3965C115.898 40.3965 67.4649 87.1053 67.4649 144.724C67.4649 202.342 115.898 249.051 175.644 249.051Z",
    fill: "#FF3F3F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C104.204 20.3547 47.9201 73.9467 47.9201 140.056C47.9201 180.177 68.6506 215.685 100.468 237.404C113.967 246.618 122.153 261.805 122.153 278.148V287.308C122.153 307.211 138.289 323.346 158.191 323.346H189.076C208.979 323.346 225.114 307.212 225.114 287.308V278.148C225.114 261.805 233.3 246.618 246.799 237.404C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "url(#paint15_linear_12_241)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.3 312.564C227.615 324.6 220.167 334.212 213.79 340.341C212.698 340.077 211.989 340.221 210.822 340.216C200.28 340.162 195.923 337.773 185.635 335.991C183.422 335.608 177.363 332.38 174.976 330.889L170.574 328.032C170.574 328.032 168.557 299.655 183.785 295.741C199.013 291.828 200.369 264.422 202.786 249.894C209.345 210.472 250.251 224.375 262.728 174.391C266.047 161.098 267.931 134.634 281.775 126.832C297.548 117.941 303.928 132.096 314.651 124.047C331.408 111.467 353.644 110.989 362.024 130.306C370.296 149.371 347.478 177.557 304.09 193.982C274.299 209.291 272.323 215.601 270.372 231.677C269.005 242.938 272.35 273.989 254.695 281.666C237.042 289.342 222.655 298.804 225.3 312.564Z",
    fill: "url(#paint16_linear_12_241)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M118.795 32.3181C130.77 32.1591 147.235 34.0023 158.969 45.1478C173.636 59.0779 166.91 74.2435 176.964 94.6304C193.877 128.93 227.967 116.534 251.393 151.883C272.697 184.033 264.785 224.898 255.891 231.22C255.093 231.786 245.727 238.161 245.727 238.161L107.034 178.465L118.795 32.3181Z",
    fill: "url(#paint17_linear_12_241)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.634 255.298C141.34 255.298 110.979 243.318 88.1414 221.566C65.298 199.808 52.7182 170.875 52.7182 140.101C52.7182 109.327 65.2994 80.3948 88.1414 58.6362C110.978 36.8833 141.34 24.9042 173.634 24.9042C205.927 24.9042 236.288 36.8847 259.126 58.6362C281.969 80.3948 294.549 109.327 294.549 140.101C294.549 170.875 281.969 199.808 259.126 221.566C236.288 243.318 205.927 255.298 173.634 255.298ZM173.634 25.8769C141.591 25.8769 111.469 37.7609 88.8145 59.3405C66.1656 80.9131 53.6938 109.594 53.6938 140.1C53.6938 170.606 66.167 199.287 88.8145 220.859C111.469 242.439 141.591 254.323 173.634 254.323C205.674 254.323 235.798 242.439 258.453 220.859C281.102 199.287 293.574 170.606 293.574 140.1C293.574 109.594 281.1 80.9131 258.453 59.3405C235.798 37.7609 205.674 25.8769 173.634 25.8769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.634 255.299C149.934 255.299 127.663 243.3 110.92 221.51C94.2062 199.76 85.0018 170.847 85.0018 140.1C85.0018 109.353 94.2062 80.4403 110.92 58.6903C127.663 36.9019 149.935 24.9015 173.634 24.9015C197.332 24.9015 219.605 36.9005 236.348 58.6903C253.061 80.4403 262.265 109.353 262.265 140.1C262.265 170.847 253.061 199.76 236.348 221.51C219.606 243.298 197.333 255.299 173.634 255.299ZM173.634 25.877C125.3 25.877 85.9774 77.1175 85.9774 140.1C85.9774 203.082 125.3 254.323 173.634 254.323C221.967 254.323 261.29 203.082 261.29 140.1C261.29 77.1175 221.967 25.877 173.634 25.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.634 255.299C161.645 255.299 150.417 243.256 142.015 221.388C133.669 199.667 129.074 170.799 129.074 140.1C129.074 109.401 133.671 80.5326 142.015 58.8124C150.417 36.9445 161.646 24.9015 173.634 24.9015C185.621 24.9015 196.851 36.9445 205.253 58.8124C213.598 80.5326 218.193 109.401 218.193 140.1C218.193 170.799 213.597 199.667 205.253 221.388C196.851 243.256 185.621 255.299 173.634 255.299ZM173.634 25.877C149.602 25.877 130.048 77.1175 130.048 140.1C130.048 203.082 149.6 254.323 173.634 254.323C197.667 254.323 217.218 203.082 217.218 140.1C217.218 77.1175 197.666 25.877 173.634 25.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.122 25.39H173.147V254.811H174.122V25.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.634 153.482C141.452 153.482 111.196 152.421 88.4368 150.497C77.358 149.56 68.6577 148.468 62.5744 147.253C53.7406 145.486 52.7182 143.872 52.7182 142.809C52.7182 141.747 53.7406 140.133 62.5744 138.366C68.6577 137.149 77.3594 136.057 88.4368 135.122C111.195 133.196 141.452 132.137 173.634 132.137C205.814 132.137 236.071 133.197 258.831 135.122C269.908 136.059 278.61 137.151 284.693 138.366C293.527 140.133 294.549 141.749 294.549 142.809C294.549 143.87 293.527 145.486 284.693 147.253C278.61 148.469 269.908 149.561 258.831 150.497C236.071 152.421 205.814 153.482 173.634 153.482ZM173.634 133.111C141.479 133.111 111.252 134.17 88.5192 136.093C55.3722 138.896 53.6938 142.18 53.6938 142.809C53.6938 143.438 55.3722 146.721 88.5192 149.526C111.252 151.449 141.479 152.508 173.634 152.508C205.788 152.508 236.015 151.449 258.748 149.526C291.895 146.723 293.574 143.44 293.574 142.809C293.574 142.179 291.895 138.896 258.748 136.093C236.015 134.169 205.788 133.111 173.634 133.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.634 110.059C118.782 110.059 62.0462 104.87 62.0462 96.1852C62.0462 91.2451 79.975 88.0487 95.0156 86.2353C116.019 83.7049 143.939 82.3119 173.634 82.3119C203.329 82.3119 231.249 83.7049 252.252 86.2353C267.292 88.0472 285.221 91.2451 285.221 96.1852C285.221 104.869 228.485 110.059 173.634 110.059ZM173.634 83.2874C107.468 83.2874 63.0217 89.9557 63.0217 96.1852C63.0217 102.413 107.468 109.083 173.634 109.083C239.798 109.083 284.246 102.415 284.246 96.1852C284.246 89.9557 239.798 83.2874 173.634 83.2874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.299 56.13C140.707 56.13 106.996 52.0632 106.996 45.2571C106.996 38.4511 140.707 34.3842 173.299 34.3842C205.89 34.3842 239.601 38.4511 239.601 45.2571C239.601 52.0632 205.89 56.13 173.299 56.13ZM173.299 35.3612C134.222 35.3612 107.972 40.4788 107.972 45.2585C107.972 50.0382 134.222 55.1559 173.299 55.1559C212.375 55.1559 238.625 50.0382 238.625 45.2585C238.625 40.4788 212.375 35.3612 173.299 35.3612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.634 197.031C143.939 197.031 116.019 195.638 95.0156 193.107C79.975 191.295 62.0462 188.097 62.0462 183.157C62.0462 178.217 79.975 175.021 95.0156 173.207C116.019 170.677 143.939 169.284 173.634 169.284C203.329 169.284 231.249 170.677 252.252 173.207C267.292 175.019 285.221 178.217 285.221 183.157C285.221 188.097 267.292 191.294 252.252 193.107C231.249 195.638 203.329 197.031 173.634 197.031ZM173.634 170.259C107.468 170.259 63.0217 176.928 63.0217 183.157C63.0217 189.385 107.468 196.055 173.634 196.055C239.798 196.055 284.246 189.387 284.246 183.157C284.246 176.929 239.798 170.259 173.634 170.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.299 244.957C140.707 244.957 106.996 240.89 106.996 234.084C106.996 227.278 140.707 223.211 173.299 223.211C205.89 223.211 239.601 227.278 239.601 234.084C239.601 240.89 205.89 244.957 173.299 244.957ZM173.299 224.188C134.222 224.188 107.972 229.306 107.972 234.085C107.972 238.865 134.222 243.983 173.299 243.983C212.375 243.983 238.625 238.865 238.625 234.085C238.625 229.306 212.375 224.188 173.299 224.188Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.629 109.148C260.17 109.148 262.23 107.089 262.23 104.548C262.23 102.007 260.17 99.9468 257.629 99.9468C255.088 99.9468 253.028 102.007 253.028 104.548C253.028 107.089 255.088 109.148 257.629 109.148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.07 113.462C218.611 113.462 220.671 111.402 220.671 108.862C220.671 106.321 218.611 104.261 216.07 104.261C213.529 104.261 211.469 106.321 211.469 108.862C211.469 111.402 213.529 113.462 216.07 113.462Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.655 153.925C263.196 153.925 265.256 151.865 265.256 149.324C265.256 146.783 263.196 144.724 260.655 144.724C258.114 144.724 256.054 146.783 256.054 149.324C256.054 151.865 258.114 153.925 260.655 153.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.45 156.535C219.991 156.535 222.051 154.475 222.051 151.934C222.051 149.393 219.991 147.333 217.45 147.333C214.91 147.333 212.85 149.393 212.85 151.934C212.85 154.475 214.91 156.535 217.45 156.535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 58,
    width: 218,
    height: 185
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.452 130.933C290.152 69.8542 217.642 41.8805 153.496 68.4511C135.331 75.9755 119.788 87.0694 107.41 100.49C110.577 110.218 114.924 117.475 119.262 122.969C142.696 152.644 172.724 139.921 215.466 174.086C248.576 200.552 245.617 220.225 274.185 234.09C283.738 238.726 293.644 241.166 303.459 242.093C303.688 241.721 303.92 241.351 304.16 240.985C325.243 208.74 330.807 168 315.452 130.933Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.238 99.287C288.585 98.3146 289.7 95.6232 288.727 93.2756C287.755 90.928 285.064 89.8133 282.716 90.7857C280.369 91.7581 279.254 94.4495 280.226 96.7971C281.199 99.1446 283.89 100.259 286.238 99.287Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.669 147.528C296.21 147.528 298.269 145.468 298.269 142.927C298.269 140.386 296.21 138.326 293.669 138.326C291.128 138.326 289.068 140.386 289.068 142.927C289.068 145.468 291.128 147.528 293.669 147.528Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.634 114.056C176.175 114.056 178.234 111.996 178.234 109.455C178.234 106.914 176.175 104.854 173.634 104.854C171.093 104.854 169.033 106.914 169.033 109.455C169.033 111.996 171.093 114.056 173.634 114.056Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.634 60.0734C176.175 60.0734 178.234 58.0136 178.234 55.4726C178.234 52.9317 176.175 50.8718 173.634 50.8718C171.093 50.8718 169.033 52.9317 169.033 55.4726C169.033 58.0136 171.093 60.0734 173.634 60.0734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.981 55.3703C230.522 55.3703 232.582 53.3104 232.582 50.7695C232.582 48.2285 230.522 46.1687 227.981 46.1687C225.44 46.1687 223.38 48.2285 223.38 50.7695C223.38 53.3104 225.44 55.3703 227.981 55.3703Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.022 49.023C241.563 49.023 243.622 46.9631 243.622 44.4222C243.622 41.8813 241.563 39.8214 239.022 39.8214C236.481 39.8214 234.421 41.8813 234.421 44.4222C234.421 46.9631 236.481 49.023 239.022 49.023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.634 30.0163C176.175 30.0163 178.234 27.9565 178.234 25.4155C178.234 22.8746 176.175 20.8148 173.634 20.8148C171.093 20.8148 169.033 22.8746 169.033 25.4155C169.033 27.9565 171.093 30.0163 173.634 30.0163Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 20,
    width: 182,
    height: 219
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M299.347 140.056C299.347 73.9467 243.063 20.3547 173.634 20.3547C153.972 20.3547 135.368 24.6558 118.796 32.3181C118 42.5165 119.238 50.8846 121.144 57.621C131.437 94.0042 164.047 93.74 190.461 141.661C210.921 178.782 200.659 195.825 221.746 219.566C228.798 227.505 237.015 233.55 245.728 238.162C246.082 237.906 246.438 237.654 246.8 237.407C278.617 215.685 299.347 180.177 299.347 140.056Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.236 200.548C214.777 200.548 216.837 198.488 216.837 195.947C216.837 193.406 214.777 191.346 212.236 191.346C209.695 191.346 207.635 193.406 207.635 195.947C207.635 198.488 209.695 200.548 212.236 200.548Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 88,
    width: 238,
    height: 146
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M248.938 121.971C202.192 75.2255 124.499 77.1293 75.4052 126.223C61.5028 140.125 51.3887 156.322 45.0891 173.458C51.7371 181.232 58.5297 186.274 64.6405 189.689C97.6456 208.137 120.517 184.892 173.079 200.1C213.795 211.881 218.59 231.188 250.288 233.065C260.888 233.692 270.973 232.156 280.395 229.256C280.464 228.825 280.537 228.395 280.619 227.964C287.757 190.107 277.307 150.341 248.938 121.971Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.562 195.111C257.359 193.315 257.359 190.402 255.562 188.605C253.765 186.808 250.852 186.808 249.056 188.605C247.259 190.402 247.259 193.315 249.056 195.111C250.852 196.908 253.765 196.908 255.562 195.111Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_12_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 108,
    width: 239,
    height: 146
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M263.661 141.977C216.916 95.2309 139.222 97.1346 90.1285 146.228C76.2261 160.131 66.112 176.327 59.8124 193.463C66.4604 201.237 73.253 206.279 79.3638 209.695C112.369 228.143 135.241 204.897 187.802 220.105C228.519 231.886 233.313 251.193 265.011 253.07C275.611 253.698 285.696 252.161 295.118 249.262C295.187 248.831 295.261 248.4 295.342 247.969C302.48 210.113 292.031 170.346 263.661 141.977Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_12_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.073 187.341C288.869 185.544 288.869 182.631 287.073 180.835C285.276 179.038 282.363 179.038 280.566 180.835C278.769 182.631 278.769 185.544 280.566 187.341C282.363 189.138 285.276 189.138 287.073 187.341Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M259.244 388.906C258.936 388.906 258.686 388.656 258.686 388.346V242.621C258.686 242.313 258.936 242.061 259.244 242.061C259.552 242.061 259.802 242.311 259.802 242.621V388.346C259.803 388.656 259.552 388.906 259.244 388.906Z",
    fill: "#B7ACB5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M298.504 379.751C298.196 379.751 297.946 379.501 297.946 379.192V238.944C297.946 238.636 298.196 238.385 298.504 238.385C298.812 238.385 299.062 238.635 299.062 238.944V379.192C299.062 379.501 298.812 379.751 298.504 379.751Z",
    fill: "#B7ACB5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M389.271 386.282C389.043 386.282 388.828 386.141 388.746 385.914L336.266 241.305C336.161 241.015 336.311 240.694 336.601 240.589C336.891 240.484 337.211 240.633 337.316 240.924L389.798 385.533C389.903 385.823 389.753 386.144 389.463 386.249C389.399 386.272 389.335 386.282 389.271 386.282Z",
    fill: "#B7ACB5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M350.798 396.264C350.559 396.264 350.338 396.11 350.264 395.87L303.161 243.405C303.07 243.11 303.235 242.798 303.531 242.707C303.826 242.616 304.138 242.782 304.229 243.076L351.332 395.541C351.423 395.836 351.258 396.148 350.963 396.239C350.909 396.255 350.852 396.264 350.798 396.264Z",
    fill: "#B7ACB5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M298.072 238.8L258.689 241.715V242.601L303.698 244.619L337.339 240.496V239.61L298.072 238.8Z",
    fill: "#B7ACB5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M298.072 237.915L258.688 241.715L303.698 243.733L337.339 239.61L298.072 237.915Z",
    fill: "#E7E9EF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M340.338 364.614C340.091 364.614 339.864 364.448 339.799 364.196C339.721 363.898 339.898 363.593 340.198 363.513L377.697 353.676C377.994 353.598 378.3 353.775 378.38 354.075C378.458 354.373 378.28 354.678 377.981 354.756L340.482 364.594C340.432 364.608 340.385 364.614 340.338 364.614Z",
    fill: "#B7ACB5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M329.715 330.102C329.448 330.102 329.213 329.912 329.166 329.641C329.112 329.337 329.315 329.047 329.619 328.993L366.422 322.477C366.729 322.425 367.017 322.626 367.07 322.93C367.124 323.234 366.921 323.524 366.617 323.578L329.813 330.094C329.779 330.1 329.746 330.102 329.715 330.102Z",
    fill: "#B7ACB5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M318.671 294.479C318.394 294.479 318.154 294.273 318.117 293.992C318.077 293.685 318.293 293.406 318.6 293.366L354.217 288.775C354.534 288.732 354.804 288.952 354.843 289.258C354.883 289.564 354.667 289.844 354.361 289.884L318.743 294.475C318.719 294.478 318.695 294.479 318.671 294.479Z",
    fill: "#B7ACB5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M311.593 269.76C311.322 269.76 311.085 269.562 311.042 269.287C310.994 268.982 311.203 268.696 311.508 268.648L344.996 263.408C345.301 263.36 345.587 263.57 345.633 263.874C345.682 264.179 345.473 264.465 345.168 264.513L311.68 269.753C311.652 269.757 311.622 269.76 311.593 269.76Z",
    fill: "#B7ACB5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9196 360.422L66.5248 366.761C66.5248 366.761 67.4251 367.714 69.1561 367.051L71.0461 360.827L66.9196 360.422Z",
    fill: "url(#paint18_linear_12_241)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7134 365.081C67.7134 365.081 64.6093 366.348 65.2128 367.721C65.5365 368.458 66.6569 370.124 67.6239 371.507C68.5199 372.788 70.1373 373.354 71.634 372.905C72.1367 372.755 72.6507 372.607 73.1051 372.491C74.0465 372.248 74.1005 370.933 73.1846 370.609C72.7401 370.453 72.3 370.327 71.9166 370.267C70.7806 370.092 69.2157 367.407 69.0325 366.332C68.8508 365.257 67.7134 365.081 67.7134 365.081Z",
    fill: "url(#paint19_linear_12_241)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2399 299.59C64.8123 301.167 81.7216 307.554 85.4903 322.213C85.6919 322.995 86.2074 325.172 86.2315 328.727C86.3309 343.523 77.73 356.047 71.4735 363.333C69.5011 363.301 67.5274 363.268 65.555 363.235C64.5695 359.459 63.6635 353.811 65.0793 347.455C67.2419 337.741 72.8552 335.22 71.7717 330.453C69.8036 321.795 49.7007 323.109 47.805 315.357C47.1192 312.557 48.6215 307.804 60.2399 299.59Z",
    fill: "url(#paint20_linear_12_241)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70425 388.186L12.2895 387.984C12.8192 387.972 13.045 387.313 12.6403 386.972C12.2413 386.637 11.6889 386.361 10.9831 386.435C9.35157 386.606 5.68798 384.322 4.02517 384.812C3.48273 384.973 3.04111 386.249 2.81533 386.603C2.37229 387.297 2.88207 388.204 3.70425 388.186Z",
    fill: "url(#paint21_linear_12_241)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56095 381.589L4.02659 384.812C4.02659 384.812 5.26056 385.734 7.06112 385.339L10.6736 382.851L7.56095 381.589Z",
    fill: "url(#paint22_linear_12_241)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4154 337.763C77.7854 331.361 80.6282 323.467 77.3793 318.985C74.092 314.45 66.8926 318.28 59.6691 314.626C56.9896 313.271 54.2362 310.845 51.9443 306.455C47.8902 310.643 47.3393 313.452 47.805 315.357C49.7007 323.109 69.805 321.796 71.7717 330.453C72.8552 335.22 67.2419 337.741 65.0793 347.455C63.8623 352.919 64.3622 357.856 65.1531 361.534C65.856 358.118 66.948 354.531 68.6193 350.908C71.208 345.296 72.9177 344.508 75.4154 337.763Z",
    fill: "url(#paint23_linear_12_241)"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8598 297.741C60.0795 310.518 54.1524 330.029 40.5702 350.394C30.5152 365.472 19.4676 376.215 10.8028 383.393C10.1865 383.578 9.13573 383.804 7.84637 383.646C6.8893 383.528 6.1296 383.24 5.6184 382.996C6.2148 379.393 7.47292 374.073 10.4577 368.326C15.919 357.808 20.7854 358.146 26.2708 348.863C30.288 342.066 31.5929 334.847 34.2029 320.407C36.2193 309.257 36.2193 306.592 38.9812 303.394C44.5689 296.93 55.0569 296.855 62.8598 297.741Z",
    fill: "url(#paint24_linear_12_241)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 370.704C14.5033 367.627 17.9624 364.421 24.7855 358.098C31.8372 351.563 31.566 352.744 32.9547 350.813C39.1686 342.168 35.8018 332.933 37.3354 321.786C38.1917 315.566 40.9365 307.439 48.9297 298.334C45.1837 299.026 41.5954 300.513 38.984 303.394C35.7777 306.932 36.0148 310.397 34.2057 320.407C31.5958 334.847 30.2894 342.066 26.2737 348.863C20.7882 358.146 15.9219 357.809 10.4606 368.326C7.47575 374.074 6.21764 379.395 5.62124 382.996C6.13244 383.239 6.89072 383.528 7.84922 383.646C8.60891 383.739 9.28199 383.697 9.83579 383.611C9.38139 376.303 11.5639 372.265 12.5537 370.704Z",
    fill: "url(#paint25_linear_12_241)"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3574 214.714C70.3574 214.714 72.6464 231.735 54.7119 243.741L73.7995 248.291C73.7995 248.291 79.9069 236.867 75.4807 217.947L70.3574 214.714Z",
    fill: "url(#paint26_linear_12_241)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7171 217.947C73.7171 217.947 74.7452 215.408 74.5791 214.265C74.4129 213.122 71.6922 211.597 69.8363 210.022C67.9818 208.447 69.9058 211.607 70.3375 212.325C70.7692 213.044 72.2829 214.122 72.0657 216.565L73.7171 217.947Z",
    fill: "url(#paint27_linear_12_241)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3632 230.91C53.3004 229.064 53.6867 229.074 53.9167 228.1C54.4407 225.879 53.086 223.059 51.9372 223.021C51.1974 222.995 51.1363 224.147 49.5687 225.942C47.6488 228.14 46.483 227.852 45.3541 229.76C45.09 230.206 43.9 232.215 44.6328 233.715C45.5671 235.627 49.2478 235.93 50.787 234.454C51.5155 233.753 51.2088 233.185 52.3632 230.91Z",
    fill: "url(#paint28_linear_12_241)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6042 232.902C49.6042 232.902 50.2616 236.411 49.7944 239.264C49.3713 241.843 44.5958 244.522 43.6814 245.29C42.7655 246.059 46.1096 246.891 49.1768 246.489C52.2439 246.087 60.6404 243.399 61.9169 241.901C63.1935 240.403 60.4316 241.141 58.1085 240.859C55.7854 240.576 53.5674 236.682 53.4992 234.696C53.4311 232.708 49.6042 232.902 49.6042 232.902Z",
    fill: "url(#paint29_linear_12_241)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6053 235.521C50.6053 235.521 52.9539 236.552 55.0328 234.888C56.8944 233.398 54.1254 228.824 52.2312 228.766C51.5993 228.746 50.6777 229.199 50.1324 229.862C49.8115 230.254 49.7916 230.514 49.2534 231.143C48.7578 231.724 48.5392 231.775 48.4639 232.058C48.3702 232.41 48.5321 232.999 49.8072 234.011C49.1725 233.895 48.6244 234.063 48.4128 234.432C48.3787 234.491 48.3091 234.676 48.3304 234.866C48.4057 235.558 49.3074 235.877 50.6053 235.521Z",
    fill: "url(#paint30_linear_12_241)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.204 223.307C102.204 223.307 103.625 223.109 103.182 220.394C102.834 218.265 103.097 217.549 103.599 217.926C104.102 218.303 104.173 219.533 104.173 219.533C104.173 219.533 106.006 217.97 106.76 215.921C107.514 213.872 108 215.597 108.162 216.621C108.324 217.645 107.084 220.825 106.384 221.419C105.684 222.012 104.66 224.625 104.66 224.625L102.204 223.307Z",
    fill: "url(#paint31_linear_12_241)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M105.992 224.035C104.375 222.901 102.756 221.77 101.139 220.636C99.1734 232.736 94.7004 237.485 90.9005 239.562C81.7344 244.575 73.551 235.647 56.0055 239.294C51.1704 240.299 42.7427 242.171 38.071 249.059C36.8427 250.87 36.4067 252.241 34.369 265.23C31.7648 281.834 31.6725 284.731 32.0402 288.306C32.7147 294.848 33.1223 298.813 36.1398 302.322C44.1514 311.638 61.1757 306.83 63.31 306.198C67.2533 305.03 73.382 303.213 75.8159 298.002C76.9618 295.55 76.8397 293.309 75.076 284.343C71.5843 266.583 71.1384 265.434 72.1125 263.489C75.397 256.924 85.8084 260.679 94.6024 254.573C99.7442 251.006 105.539 243.227 105.992 224.035Z",
    fill: "url(#paint32_linear_12_241)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.3324 303.83C57.0478 300.308 54.7403 297.065 57.2707 292.832C60.4955 287.437 66.2991 289.268 68.483 285.283C72.2162 278.467 57.515 268.965 60.4998 258.114C61.9255 252.934 66.904 249.183 71.0646 247.763C80.3002 244.607 86.3423 252.646 95.0014 250.13C97.0533 249.533 99.4091 248.298 101.79 245.736C99.686 250.179 97.0704 252.863 94.6052 254.576C85.8112 260.68 75.3998 256.927 72.1153 263.492C71.1427 265.437 71.5885 266.586 75.0789 284.346C76.8411 293.312 76.9632 295.553 75.8187 298.005C73.3848 303.216 67.2561 305.032 63.3128 306.201C62.1441 306.548 56.5139 308.141 50.3426 307.988C53.0945 306.867 54.5756 305.383 55.3324 303.83Z",
    fill: "url(#paint33_linear_12_241)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M130.868 191.755C134.879 193.79 139.917 191.92 142.121 187.578C144.325 183.234 142.861 178.064 138.849 176.027C138.642 175.922 138.429 175.833 138.218 175.749C138.962 173.346 139.524 170.924 139.9 168.501C140.13 168.501 140.36 168.497 140.595 168.476C145.17 168.067 148.801 163.862 148.704 159.083C148.608 154.303 144.819 150.76 140.244 151.169C140.005 151.19 139.77 151.229 139.537 151.27C139.058 148.901 138.404 146.588 137.577 144.349C137.787 144.225 137.997 144.099 138.202 143.955C142.117 141.212 143.366 135.799 140.995 131.864C138.624 127.929 133.527 126.964 129.614 129.707C129.414 129.848 129.225 130 129.039 130.154C127.492 128.445 125.795 126.861 123.961 125.416C124.09 125.204 124.216 124.99 124.33 124.765C126.534 120.422 129.415 115.678 125.372 113.705C116.02 109.143 112.009 113.051 109.805 117.394C109.691 117.619 109.592 117.847 109.498 118.077C107.247 117.45 104.968 117.015 102.676 116.777C102.691 116.535 102.702 116.294 102.696 116.048C102.6 111.27 104.017 108.683 99.4247 108.595C89.4081 108.401 86.0299 112.749 86.1264 117.529C86.1321 117.779 86.152 118.023 86.1776 118.266C83.8828 118.921 81.6279 119.757 79.434 120.77C79.3303 120.557 79.221 120.345 79.0975 120.139C76.7261 116.204 71.6297 115.239 67.7162 117.984C63.8013 120.727 62.5517 126.14 64.9231 130.075C65.0438 130.276 65.1773 130.465 65.3122 130.651C63.5783 132.385 61.9553 134.268 60.4558 136.289C60.2612 136.167 60.0653 136.049 59.8565 135.942C55.845 133.906 50.8069 135.778 48.6031 140.12C46.3992 144.464 47.8633 149.634 51.8747 151.67C52.0821 151.775 52.2951 151.865 52.5081 151.948C51.764 154.351 51.2017 156.774 50.8254 159.196C50.5953 159.198 50.3653 159.2 50.131 159.222C45.5543 159.631 41.9234 163.837 42.0214 168.615C42.118 173.395 45.9065 176.938 50.4817 176.529C50.7203 176.507 50.956 176.469 51.1889 176.428C51.6674 178.796 52.322 181.109 53.1499 183.349C52.9397 183.472 52.7296 183.599 52.5251 183.742C48.6102 186.486 47.3606 191.899 49.732 195.833C52.1034 199.768 59.9531 201.594 63.868 198.851C64.0682 198.71 61.5037 197.698 61.6897 197.543C63.2361 199.253 64.933 200.836 66.7677 202.282C66.6384 202.493 66.5121 202.708 66.3985 202.932C64.1946 207.276 65.6586 212.446 69.6701 214.482C73.6816 216.518 78.7197 214.647 80.9236 210.305C81.0372 210.08 81.1366 209.852 81.2303 209.622C83.481 210.249 85.7601 210.684 88.052 210.922C88.0378 211.164 88.0264 211.405 88.0321 211.651C88.1286 216.43 91.9172 219.973 96.4924 219.564C101.068 219.155 104.699 214.949 104.602 210.171C104.596 209.921 104.576 209.677 104.551 209.434C106.846 208.779 109.101 207.943 111.294 206.931C111.398 207.144 111.507 207.355 111.631 207.561C114.002 211.496 119.099 212.462 123.012 209.718C126.927 206.975 128.177 201.562 125.805 197.627C125.683 197.425 125.551 197.236 125.416 197.052C127.15 195.318 128.773 193.435 130.273 191.414C130.463 191.531 130.659 191.65 130.868 191.755ZM80.8696 192.398C66.3061 185.007 60.9883 166.232 68.9899 150.463C76.993 134.694 95.2854 127.902 109.849 135.293C124.412 142.684 129.73 161.46 121.729 177.229C113.727 192.998 95.4331 199.789 80.8696 192.398Z",
    fill: "#E85F53"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M140.595 168.474C145.17 168.065 148.801 163.859 148.704 159.081C148.608 154.301 144.819 150.758 140.244 151.167C140.005 151.189 139.77 151.227 139.537 151.268C139.058 148.9 138.404 146.587 137.577 144.347C137.787 144.224 137.997 144.097 138.202 143.954C142.117 141.21 146.959 134.582 144.196 130.913C138.952 123.946 133.527 126.964 129.614 129.707C129.414 129.848 129.225 130 129.039 130.153C127.492 128.443 125.795 126.86 123.961 125.414C124.09 125.203 124.216 124.988 124.33 124.764C125.53 122.4 125.635 119.794 124.843 117.579C121.063 124.234 117.334 130.918 113.672 137.639C125.29 146.149 128.992 162.925 121.733 177.229C115.581 189.35 103.351 196.157 91.4074 195.307C90.8749 196.688 90.3524 198.077 89.7815 199.446C88.2337 203.159 86.4758 206.797 84.715 210.429C85.8226 210.638 86.9344 210.803 88.0505 210.919C88.0363 211.161 88.025 211.404 88.0307 211.648C88.1272 216.428 91.0297 220.487 99.3225 220.046C103.91 219.801 104.697 214.947 104.601 210.168C104.595 209.918 104.575 209.674 104.549 209.431C106.844 208.777 109.099 207.94 111.293 206.928C111.397 207.141 111.506 207.352 111.63 207.558C114.001 211.493 122.227 213.163 126.14 210.42C130.055 207.676 128.177 201.557 125.804 197.623C125.682 197.421 125.55 197.232 125.415 197.046C127.149 195.312 128.772 193.429 130.271 191.409C130.466 191.531 130.662 191.649 130.871 191.755C134.882 193.791 139.92 191.92 142.124 187.578C144.328 183.235 142.864 178.064 138.852 176.027C138.645 175.922 138.432 175.833 138.22 175.749C138.964 173.346 139.527 170.924 139.903 168.501C140.129 168.5 140.359 168.496 140.595 168.474Z",
    fill: "#E85F53"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M135.182 192.245C139.193 194.281 144.231 192.41 146.435 188.067C148.639 183.724 147.175 178.554 143.163 176.517C142.956 176.412 142.743 176.323 142.53 176.239C143.274 173.836 143.836 171.414 144.213 168.991C144.443 168.991 144.673 168.987 144.907 168.966C149.482 168.557 153.113 164.352 153.017 159.572C152.92 154.793 149.132 151.25 144.556 151.659C144.318 151.68 144.082 151.718 143.849 151.76C143.371 149.391 142.716 147.078 141.888 144.839C142.098 144.715 142.309 144.589 142.513 144.445C146.428 141.702 147.678 136.289 145.306 132.354C142.935 128.419 137.838 127.454 133.925 130.197C133.725 130.338 133.536 130.49 133.35 130.643C131.803 128.933 130.107 127.35 128.272 125.904C128.401 125.693 128.528 125.478 128.641 125.254C130.845 120.91 129.381 115.74 125.369 113.704C121.358 111.667 116.32 113.539 114.116 117.881C114.002 118.106 113.903 118.334 113.809 118.564C111.559 117.937 109.279 117.502 106.988 117.264C107.002 117.022 107.013 116.781 107.007 116.535C106.911 111.756 103.122 108.213 98.5472 108.622C93.9719 109.031 90.341 113.237 90.4375 118.015C90.4432 118.265 90.4631 118.509 90.4887 118.752C88.194 119.406 85.939 120.243 83.7451 121.255C83.6414 121.042 83.5321 120.831 83.4086 120.625C81.0372 116.69 75.9408 115.724 72.0273 118.469C68.1124 121.213 66.8628 126.626 69.2342 130.561C69.3563 130.762 69.4884 130.951 69.6233 131.137C67.8895 132.871 66.2664 134.754 64.7669 136.774C64.5723 136.652 64.3764 136.534 64.1676 136.428C60.1562 134.392 55.118 136.263 52.9142 140.606C50.7104 144.949 52.1744 150.12 56.1859 152.156C56.3932 152.261 56.6062 152.35 56.8192 152.434C56.0751 154.837 55.5128 157.259 55.1365 159.682C54.9064 159.683 54.6764 159.686 54.4421 159.707C49.8669 160.116 46.2359 164.322 46.3325 169.101C46.4291 173.88 50.2176 177.423 54.7928 177.014C55.0314 176.993 55.2671 176.955 55.5 176.913C55.9785 179.282 56.6332 181.595 57.461 183.834C57.2509 183.958 57.0407 184.084 56.8362 184.228C52.9213 186.971 51.6717 192.384 54.0431 196.319C56.4145 200.254 61.5108 201.219 65.4243 198.476C65.6246 198.335 65.8134 198.184 65.9994 198.03C67.5458 199.74 69.2427 201.323 71.0773 202.769C70.9481 202.98 70.8217 203.195 70.7081 203.419C68.5043 207.763 69.9683 212.933 73.9798 214.969C77.9913 217.004 83.0294 215.134 85.2333 210.792C85.3469 210.567 85.4463 210.339 85.54 210.109C87.7907 210.736 90.0698 211.171 92.3616 211.409C92.3474 211.651 92.3361 211.892 92.3418 212.138C92.4383 216.916 96.2269 220.46 100.802 220.051C105.377 219.642 109.008 215.436 108.912 210.658C108.906 210.408 108.886 210.164 108.861 209.921C111.155 209.267 113.41 208.43 115.604 207.418C115.708 207.631 115.817 207.842 115.941 208.048C118.312 211.983 123.408 212.949 127.322 210.205C131.237 207.462 132.486 202.049 130.115 198.114C129.993 197.912 129.861 197.723 129.725 197.537C131.458 195.804 133.081 193.921 134.581 191.9C134.777 192.021 134.973 192.14 135.182 192.245ZM85.1836 192.888C70.6201 185.497 65.3022 166.722 73.3039 150.953C81.307 135.184 99.5994 128.392 114.163 135.783C128.726 143.174 134.044 161.95 126.043 177.719C118.041 193.488 99.747 200.279 85.1836 192.888Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M189.076 323.835H158.191C138.05 323.835 121.666 307.449 121.666 287.309V278.149C121.666 262.066 113.639 246.986 100.194 237.808C84.2194 226.904 70.9552 212.4 61.836 195.867C52.4129 178.784 47.433 159.486 47.433 140.057C47.433 107.95 60.5637 77.7636 84.4054 55.0622C108.24 32.3664 139.93 19.8676 173.635 19.8676C207.34 19.8676 239.029 32.3664 262.865 55.0622C286.706 77.7636 299.837 107.948 299.837 140.057C299.837 159.486 294.857 178.784 285.434 195.867C276.315 212.4 263.051 226.904 247.076 237.808C233.631 246.986 225.604 262.066 225.604 278.149V287.309C225.603 307.449 209.217 323.835 189.076 323.835ZM173.634 20.8417C140.18 20.8417 108.73 33.2454 85.0771 55.7665C61.4313 78.282 48.4085 108.217 48.4085 140.055C48.4085 159.318 53.3473 178.454 62.6908 195.393C71.7362 211.794 84.8953 226.18 100.744 236.999C114.455 246.358 122.642 261.741 122.642 278.146V287.307C122.642 306.908 138.59 322.856 158.193 322.856H189.077C208.679 322.856 224.628 306.908 224.628 287.307V278.146C224.628 261.741 232.815 246.358 246.526 236.999C262.375 226.18 275.534 211.793 284.581 195.393C293.924 178.454 298.863 159.318 298.863 140.055C298.863 108.215 285.84 78.282 262.194 55.7665C238.537 33.2454 207.087 20.8417 173.634 20.8417Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M230.984 258.653C233.636 258.653 235.785 256.503 235.785 253.852C235.785 251.2 233.636 249.051 230.984 249.051C228.333 249.051 226.183 251.2 226.183 253.852C226.183 256.503 228.333 258.653 230.984 258.653Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M194.141 285.324C196.161 285.324 197.799 283.687 197.799 281.666C197.799 279.646 196.161 278.009 194.141 278.009C192.121 278.009 190.483 279.646 190.483 281.666C190.483 283.687 192.121 285.324 194.141 285.324Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M193.68 283.001L193.086 282.227L230.798 253.38L230.936 253.366L285.762 247.805L285.86 248.775L231.172 254.322L193.68 283.001Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M287.223 252.43C289.089 251.657 289.975 249.518 289.202 247.651C288.429 245.785 286.289 244.898 284.423 245.671C282.556 246.445 281.67 248.584 282.443 250.451C283.216 252.317 285.356 253.204 287.223 252.43Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M279.455 235.505C279.455 235.505 270.509 240.051 270.362 240.776C270.216 241.502 276.115 240.533 278.523 240.637C280.931 240.742 282.912 239.946 282.695 238.805C282.476 237.665 281.634 234.797 281.634 234.797L279.455 235.505Z",
    fill: "url(#paint34_linear_12_241)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M279.128 231.816L279.672 236.319C279.672 236.319 281.088 236.883 282.039 236.217L282.445 231.278L279.128 231.816Z",
    fill: "url(#paint35_linear_12_241)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M321.255 231.924L322.296 233.791C322.587 234.314 322.673 234.943 322.534 235.538C322.171 237.091 321.444 240.117 321.127 240.907C320.695 241.982 314.906 242.621 314.906 242.621C314.906 242.621 314.389 241.809 315.592 240.827C316.793 239.846 317.566 239.691 317.99 238.244C318.415 236.797 318.698 232.702 318.698 232.702L321.255 231.924Z",
    fill: "url(#paint36_linear_12_241)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M316.924 227.178C317.305 227.516 319.163 233.827 319.163 233.827C319.163 233.827 319.765 234.687 320.908 233.418C322.052 232.148 321.425 232.848 321.425 232.848L321.211 226.643L316.924 227.178Z",
    fill: "url(#paint37_linear_12_241)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M274.206 141.344C273.735 154.777 273.715 169.372 274.406 184.962C275.185 202.519 276.749 218.746 278.72 233.456C279.453 233.482 280.223 233.486 281.028 233.462C281.572 233.445 282.097 233.415 282.606 233.377C283.628 230.327 284.838 226.315 285.92 221.524C287.059 216.486 287.745 211.967 288.234 207.646C289.957 192.431 287.938 191.105 289.336 179.829C290.575 169.842 292.335 169.453 294.403 155.274C296.645 139.89 294.977 137.582 294.164 136.749C290.707 133.197 282.587 135.614 274.206 141.344Z",
    fill: "url(#paint38_linear_12_241)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M294.163 136.747C290.866 133.362 283.327 135.411 275.365 140.579C284.525 151.645 285.524 158.823 284.426 163.48C283.185 168.744 279.412 170.261 279.426 176.016C279.445 183.089 285.153 184.963 285.032 192.448C284.951 197.398 282.444 197.346 281.85 203.46C281.149 210.694 284.427 213.186 283.365 218.538C282.908 220.84 281.604 223.849 277.893 226.948C278.16 229.147 278.435 231.322 278.72 233.456C279.453 233.482 280.223 233.486 281.028 233.46C281.572 233.443 282.097 233.414 282.606 233.375C283.628 230.325 284.838 226.314 285.92 221.523C287.059 216.484 287.744 211.966 288.234 207.645C289.957 192.43 287.938 191.103 289.336 179.827C290.575 169.84 292.335 169.451 294.403 155.273C296.644 139.888 294.975 137.581 294.163 136.747Z",
    fill: "url(#paint39_linear_12_241)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M279.879 141.118C287.767 154.022 296.274 170.08 303.883 189.303C309.632 203.829 313.803 217.469 316.864 229.624C317.279 229.838 318.256 230.266 319.504 230.081C321.207 229.83 322.228 228.614 322.495 228.275C323.741 219.562 323.604 212.182 323.18 206.855C322.909 203.445 322.431 197.766 320.487 190.756C318.31 182.903 316.812 182.461 313.972 174.153C311.024 165.529 311.737 163.378 308.914 152.586C307.754 148.153 305.812 141.556 302.608 133.665C295.032 136.148 287.455 138.633 279.879 141.118Z",
    fill: "url(#paint40_linear_12_241)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M270.398 84.0756C264.111 77.2269 260.735 76.9699 259.675 71.9886C258.629 67.0612 260.404 60.1188 264.921 57.3527C265.253 57.1496 268.671 55.1304 272.241 56.5362C277.641 58.6619 276.255 65.8159 281.69 70.641C286.295 74.7292 292.568 74.279 296.815 73.9752C307.039 73.241 309.952 67.6661 314.597 69.8572C320.417 72.6034 318.449 82.586 324.395 84.7487C328.368 86.1928 330.43 82.1643 336.09 82.3531C342.741 82.5746 348.608 88.4293 351.215 94.3933C355.981 105.295 350.653 118.395 344.108 125.552C338.731 131.432 328.904 137.267 322.739 133.9C317.867 131.241 317.846 124.24 313.196 123.75C309.891 123.402 308.892 126.836 304.671 127.657C297.738 129.006 291.523 121.481 289.828 119.429C284.995 113.579 286.648 111.047 281.208 100.401C279.06 96.1967 275.966 90.1404 270.398 84.0756Z",
    fill: "url(#paint41_linear_12_241)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M215.403 62.9276C215.403 62.9276 213.932 60.8686 212.997 59.3378C212.063 57.8071 207.704 53.5073 207.704 53.5073C207.704 53.5073 207.371 54.1889 208.31 55.2809C209.249 56.3729 211.224 58.243 210.769 59.0354C210.315 59.8263 209.037 60.5249 209.96 62.0188C210.883 63.514 212.486 62.4931 213.307 63.6915C214.126 64.89 214.967 66.1978 214.967 66.1978L215.403 62.9276Z",
    fill: "url(#paint42_linear_12_241)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M215.978 61.5842C214.985 63.2641 213.993 64.9425 213 66.621C214.034 69.9963 215.815 74.6837 218.936 79.6281C220.312 81.8092 224.58 88.2091 231.807 93.3552C241.644 100.36 259.566 106.896 264.812 99.4413C269.493 92.79 261.937 78.0448 260.546 75.3979C257.73 76.8747 253.102 78.8329 247.154 79.2958C245.204 79.4478 240.131 79.7928 234.414 77.8304C223.833 74.198 217.96 65.0263 215.978 61.5842Z",
    fill: "url(#paint43_linear_12_241)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M249.068 84.0912C249.564 86.579 257.3 85.2442 258.897 89.7598C259.754 92.1823 257.935 93.7216 257.859 97.8368C257.774 102.443 259.969 105.059 261.654 108.684C264.12 113.992 264.13 119.195 264.148 129.601C264.174 144.413 260.899 147.392 263.695 152.166C267.335 158.38 276.074 158.776 278.435 158.884C286.512 159.25 287.47 154.96 296.236 154.448C306.246 153.863 307.671 159.303 314.831 156.982C321.37 154.862 323.571 149.224 328.663 150.391C331.845 151.121 332.69 153.714 335.692 153.432C338.71 153.15 341.829 150.159 342.041 147.094C342.305 143.282 338.139 138.481 331.61 138.474C329.015 139.492 324.714 140.672 319.932 139.362C312.095 137.213 308.019 129.763 303.492 121.488C300.36 115.764 294.604 105.242 294.535 91.4454C294.507 85.7554 295.468 84.0912 294.082 81.0496C289.579 71.1749 272.106 72.6475 270.626 72.7909C258.72 73.9368 248.47 81.0865 249.068 84.0912Z",
    fill: "url(#paint44_linear_12_241)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M245.165 96.5189L267.111 97.476C267.352 97.486 267.562 97.6592 267.644 97.9134L277.983 129.98C278.131 130.44 277.667 131.59 277.232 131.537L255.535 128.237C255.315 128.21 255.126 128.049 255.046 127.817L244.29 97.8864C244.136 97.4434 244.74 96.5005 245.165 96.5189Z",
    fill: "url(#paint45_linear_12_241)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M244.825 97.3028L266.771 98.2598C267.013 98.2698 267.223 98.443 267.305 98.6972L277.643 130.764C277.79 131.224 277.457 131.698 277.022 131.645L255.194 129.021C254.974 128.994 254.785 128.832 254.704 128.601L244.249 98.2016C244.097 97.7586 244.399 97.2843 244.825 97.3028Z",
    fill: "url(#paint46_linear_12_241)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M250.826 98.497L249.98 95.941C249.903 95.711 250.056 95.4653 250.276 95.4653H258.265C258.403 95.4653 258.525 95.5647 258.566 95.7124L259.37 98.5396C259.435 98.7725 259.276 99.0068 259.059 98.9997L251.113 98.7285C250.984 98.7242 250.87 98.6333 250.826 98.497Z",
    fill: "url(#paint47_linear_12_241)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M264.334 123.884C262.909 118.715 265.255 115.35 262.861 111.334C259.474 105.654 252.198 108.058 249.936 103.474C249.325 102.239 249.034 100.396 249.856 97.5229L244.824 97.3042C244.399 97.2858 244.095 97.7586 244.249 98.2031L254.704 128.602C254.784 128.834 254.972 128.996 255.194 129.023L268.461 130.619C266.097 128.314 264.914 125.985 264.334 123.884Z",
    fill: "url(#paint48_linear_12_241)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M280.36 120.044C280.36 120.044 277.045 119.307 275.765 118.407C274.486 117.506 273.13 116.059 271.244 116.139C269.358 116.219 267.461 117.291 268.332 117.536C269.204 117.782 270.829 119.715 272.073 120.474C273.316 121.235 276.157 121.304 276.686 121.262C277.214 121.221 279.303 122.626 279.303 122.626L280.36 120.044Z",
    fill: "url(#paint49_linear_12_241)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M331.608 138.473C329.014 139.491 324.713 140.671 319.93 139.36C312.093 137.212 308.018 129.761 303.491 121.487C300.358 115.763 294.603 105.241 294.533 91.4439C294.505 85.754 295.466 84.0898 294.08 81.0481C293.86 80.5653 293.599 80.1152 293.321 79.6849C289.9 82.2707 288.574 84.8594 288.186 87.1328C287.243 92.6665 291.692 97.1921 289.376 101.965C287.158 106.537 281.675 105.272 280.532 109.191C279.3 113.418 285.367 115.969 285.634 122.502C285.955 130.342 277.525 134.182 279.002 139.426C280.282 143.971 287.338 143.643 287.335 146.081C287.331 148.979 287.554 142.995 279.002 139.426C276.41 138.344 264.212 147.346 262.73 145.766C262.41 148.32 262.469 150.07 263.695 152.164C267.335 158.378 276.074 158.774 278.435 158.882C286.512 159.249 287.47 154.959 296.236 154.446C306.246 153.861 307.671 159.301 314.831 156.981C321.37 154.861 323.571 149.222 328.663 150.389C331.845 151.119 332.69 153.712 335.692 153.431C338.709 153.148 341.829 150.158 342.041 147.092C342.303 143.282 338.137 138.481 331.608 138.473Z",
    fill: "url(#paint50_linear_12_241)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M280.275 118.508C279.254 120.537 278.235 122.565 277.214 124.592C278.787 125.454 295.607 134.352 307.798 125.544C309.306 124.455 313.311 121.561 315.47 115.892C317.85 109.644 316.515 103.836 315.649 100.063C313.505 90.724 307.443 80.9275 298.84 76.9927C295.554 75.4889 291.654 74.7292 287.984 74.0135C284.873 73.4072 279.983 72.6631 279.878 73.1899C279.827 73.4469 280.964 73.775 281.752 74.2748C286.599 77.3406 280.446 89.9998 286.141 96.0717C291.598 101.888 298.68 100.927 299.822 106.198C300.353 108.649 299.254 110.852 298.765 111.835C296.036 117.312 288.687 119.764 280.275 118.508Z",
    fill: "url(#paint51_linear_12_241)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M268.86 63.6844C268.86 63.6844 270.835 70.1042 273.296 71.1053C275.755 72.105 279.645 73.2524 280.133 73.6968C280.622 74.1413 267.064 79.063 259.461 76.7981C261.626 75.7388 262.206 75.3994 262.206 75.3994C262.784 75.06 263.863 74.431 264.875 73.4285C265.564 72.7469 266.643 71.4774 267.456 69.3673L266.746 65.7221L268.86 63.6844Z",
    fill: "url(#paint52_linear_12_241)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M269.747 66.4875C269.747 66.4875 268.603 69.3332 265.888 68.8958C263.457 68.5053 263.58 61.668 265.232 60.5036C265.783 60.116 266.9 59.9683 267.73 60.3077C268.313 60.5462 270.05 62.1366 269.662 64.4654C270.198 64.1473 270.732 64.197 270.916 64.4839C271.152 64.8474 270.77 65.5063 270.685 65.6554C270.385 66.1708 269.951 66.398 269.747 66.4875Z",
    fill: "url(#paint53_linear_12_241)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M281.827 350.868L313.96 326.192L308.537 319.482L276.463 344.23L281.827 350.868Z",
    fill: "url(#paint54_linear_12_241)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M291.473 365.976L326.936 339.004L317.113 326.848L281.762 353.96L291.473 365.976Z",
    fill: "url(#paint55_linear_12_241)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M304.35 397.057L343.295 399L353.355 363.117L328.206 341.073L292.856 368.185L304.35 397.057Z",
    fill: "url(#paint56_linear_12_241)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M230.395 262.637L228.732 260.581L230.37 259.252L276.133 315.88L279.094 315.438L280.206 312.699L234.38 255.994L236.023 254.661L237.688 256.723L309.337 292.97L309.838 315.538L293.007 328.541L288.916 331.699L272.315 344.524L250.538 338.835L230.395 262.637Z",
    fill: "url(#paint57_linear_12_241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_241",
    x1: 345.46,
    y1: 110.267,
    x2: 142.151,
    y2: 365.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_241",
    x1: 348.241,
    y1: 207.95,
    x2: 183.556,
    y2: 342.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E3352F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63B25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_241",
    x1: 328.981,
    y1: 242.074,
    x2: 148.379,
    y2: 501.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_241",
    x1: 171.015,
    y1: 397.666,
    x2: 173.248,
    y2: 379.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_241",
    x1: 161.833,
    y1: 381.386,
    x2: 184.16,
    y2: 341.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_241",
    x1: 136.583,
    y1: 362.341,
    x2: 210.685,
    y2: 362.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_241",
    x1: 163.958,
    y1: 370.405,
    x2: 186.006,
    y2: 327.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_241",
    x1: 133.263,
    y1: 349.852,
    x2: 213.968,
    y2: 349.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_241",
    x1: 132.067,
    y1: 335.27,
    x2: 215.2,
    y2: 335.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_241",
    x1: 171.569,
    y1: 328.999,
    x2: 179.756,
    y2: 290.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_241",
    x1: 267.923,
    y1: 452.691,
    x2: 0.283332,
    y2: 415.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_241",
    x1: 126.176,
    y1: 313.686,
    x2: 159.294,
    y2: 216.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12_241",
    x1: 157.838,
    y1: 324.524,
    x2: 190.956,
    y2: 227.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_241",
    x1: 114.643,
    y1: 309.738,
    x2: 147.761,
    y2: 212.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBEEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12_241",
    x1: 161.547,
    y1: 57.0103,
    x2: 129.173,
    y2: 323.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0271,
    stopColor: "#FD1715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#FE2A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1234,
    stopColor: "#FE3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1896,
    stopColor: "#FF3F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FF413F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#FD363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F81A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F81A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12_241",
    x1: 134.209,
    y1: 224.761,
    x2: 227.138,
    y2: 25.1009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#E85F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12_241",
    x1: 345.46,
    y1: 110.267,
    x2: 142.151,
    y2: 365.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12_241",
    x1: 107.034,
    y1: 135.234,
    x2: 265.002,
    y2: 135.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0271,
    stopColor: "#FD1715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#FE2A28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1234,
    stopColor: "#FE3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1896,
    stopColor: "#FF3F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    stopColor: "#FF413F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5203,
    stopColor: "#FD363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    stopColor: "#F81A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F81A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12_241",
    x1: 66.0723,
    y1: 364.108,
    x2: 71.4491,
    y2: 363.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12_241",
    x1: 72.6878,
    y1: 340.183,
    x2: 67.0188,
    y2: 392.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C1A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F0904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12_241",
    x1: 81.4121,
    y1: 390.545,
    x2: 39.9822,
    y2: 386.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12_241",
    x1: 28.3743,
    y1: 334.273,
    x2: 11.6212,
    y2: 377.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C1A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F0904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12_241",
    x1: 4.1711,
    y1: 383.269,
    x2: 10.5782,
    y2: 383.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12_241",
    x1: 104.484,
    y1: 349.495,
    x2: 47.343,
    y2: 330.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79231F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12_241",
    x1: 55.7055,
    y1: 420.566,
    x2: -5.65795,
    y2: 413.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12_241",
    x1: 41.0912,
    y1: 316.635,
    x2: 8.80524,
    y2: 381.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79231F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12_241",
    x1: 65.6644,
    y1: 248.152,
    x2: 66.8925,
    y2: 194.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12_241",
    x1: 71.7803,
    y1: 212.766,
    x2: 70.9919,
    y2: 224.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12_241",
    x1: 49.1249,
    y1: 232.956,
    x2: 49.5217,
    y2: 219.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C1A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F0904"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12_241",
    x1: 51.3418,
    y1: 220.368,
    x2: 55.0694,
    y2: 276.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12_241",
    x1: 41.6642,
    y1: 226.588,
    x2: 54.8402,
    y2: 234.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_12_241",
    x1: 103.846,
    y1: 223.486,
    x2: 101.619,
    y2: 230.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F3441C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF413F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12_241",
    x1: 23.5188,
    y1: 322.496,
    x2: 91.6338,
    y2: 222.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12_241",
    x1: 81.9287,
    y1: 246.286,
    x2: 68.1426,
    y2: 318.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_12_241",
    x1: 274.946,
    y1: 219.638,
    x2: 277.439,
    y2: 251.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_12_241",
    x1: 280.866,
    y1: 237.34,
    x2: 280.414,
    y2: 204.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_12_241",
    x1: 316.921,
    y1: 215.927,
    x2: 319.42,
    y2: 247.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_12_241",
    x1: 319.355,
    y1: 236.746,
    x2: 318.903,
    y2: 203.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_12_241",
    x1: 273.867,
    y1: 184.282,
    x2: 295.526,
    y2: 184.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79231F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_12_241",
    x1: 275.364,
    y1: 184.283,
    x2: 295.526,
    y2: 184.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79231F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_12_241",
    x1: 279.88,
    y1: 181.895,
    x2: 323.481,
    y2: 181.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79231F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_12_241",
    x1: 302.335,
    y1: 79.0025,
    x2: 329.998,
    y2: 121.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_12_241",
    x1: 207.647,
    y1: 59.8543,
    x2: 215.403,
    y2: 59.8543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_12_241",
    x1: 244.317,
    y1: 95.3788,
    x2: 278.87,
    y2: 219.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#D74A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_12_241",
    x1: 284.599,
    y1: 84.1373,
    x2: 319.152,
    y2: 207.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#D74A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_12_241",
    x1: 264.5,
    y1: 108.481,
    x2: 250.928,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#D74A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F91E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_12_241",
    x1: 273.728,
    y1: 107.672,
    x2: 240.103,
    y2: 125.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_12_241",
    x1: 258.442,
    y1: 84.8956,
    x2: 254.451,
    y2: 97.9561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#4F0904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1A09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_12_241",
    x1: 272.428,
    y1: 105.516,
    x2: 238.973,
    y2: 123.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF391D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_12_241",
    x1: 268.114,
    y1: 119.38,
    x2: 280.361,
    y2: 119.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440819"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_12_241",
    x1: 262.564,
    y1: 119.294,
    x2: 342.051,
    y2: 119.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#D74A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_12_241",
    x1: 288.298,
    y1: 83.1049,
    x2: 322.852,
    y2: 206.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F91E1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#D74A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_12_241",
    x1: 269.359,
    y1: 76.3258,
    x2: 280.024,
    y2: 50.8422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_12_241",
    x1: 265.326,
    y1: 65.7639,
    x2: 289.008,
    y2: 43.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_12_241",
    x1: 309.274,
    y1: 364.267,
    x2: 270.172,
    y2: 356.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_12_241",
    x1: 321.29,
    y1: 382.679,
    x2: 274.061,
    y2: 373.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_12_241",
    x1: 345.794,
    y1: 423.729,
    x2: 282.116,
    y2: 412.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_12_241",
    x1: 299.701,
    y1: 382.886,
    x2: 213.671,
    y2: 369.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17007,
    stopColor: "#E21B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87101E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsImage);
export default __webpack_public_path__ + "static/media/SolutionsImage.3b6647c59b9024b9ec738dd6e9676cd8.svg";
export { ForwardRef as ReactComponent };